import { render, staticRenderFns } from "./BankCooperations.vue?vue&type=template&id=799d6b7d&scoped=true&"
import script from "./BankCooperations.vue?vue&type=script&lang=js&"
export * from "./BankCooperations.vue?vue&type=script&lang=js&"
import style0 from "./BankCooperations.vue?vue&type=style&index=0&id=799d6b7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799d6b7d",
  null
  
)

export default component.exports